import React from 'react';
import DATA from '../../assets/data';
import {valueConverter} from '../../util-functions/util-funtions';
import './targetTracker.styles.scss';

const TargetYTDBrandTable = ({
    tableData,
    showTotalCol
}) => {

    const calculateTotal = (data) => {
        if (data) {
            let total = 0;
            total = data.reduce((a, b) => a + (b.Volume || 0), 0);
            return total;
        }
        else {
            return 0;
        }
    };

    return (
        <table className='target-tracker-table'>
            <thead>
                <tr>
                    <th className='tt-table-header tt-table-cell'>Category</th>
                    <th className='tt-table-header tt-table-cell'>Brand</th>
                    {
                        DATA.QUARTER_MONTHS.map(item => (
                            <th className='tt-table-header tt-table-cell' key={item.value}>{item.name}</th>
                        ))
                    }
                    {showTotalCol && <th className='tt-table-header tt-table-cell'>Total</th>}
                </tr>
            </thead>
            <tbody>
                {
                    tableData &&
                    tableData.map(item => {
                        return (
                            item.BrandData.map(elm => (
                                <tr key={elm.BrandName}>
                                    <td className='tt-table-cell' style={{textAlign:'left'}}>{item.CategoryName}</td>
                                    <td className='tt-table-cell' style={{textAlign:'left'}}>{elm.BrandName}</td>
                                    {
                                        elm.MonthData.map(month => (
                                            <td className='tt-table-cell' key={month.MonthNo}>{valueConverter(month.Volume)}</td>
                                        ))
                                    }
                                    {showTotalCol && <td className='tt-table-cell'>{valueConverter(calculateTotal(elm.MonthData))}</td>}
                                </tr>
                            ))
                        )
                    }
                    )
                }
            </tbody>
        </table>
    )
};

export default TargetYTDBrandTable;
